import React from 'react'
import i18next from 'i18next'
import { DataListItem } from '@node-space/ui-components'

interface ProcessingFeeProps {
  amountWithCurrency: string
}

const ProcessingFee = ({ amountWithCurrency }: ProcessingFeeProps) => {
  return (
    <>
      {amountWithCurrency && (
        <DataListItem
          id="processing-fee"
          testId="processing-fee"
          title={i18next.t('transactions.sideBar.processingFee')}
          body={amountWithCurrency}
        />
      )}
    </>
  )
}

export default ProcessingFee
